import { Card, CardContent } from "@/components/ui/card";

export function StatusCard({ label, value, tone, testid }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700 border-slate-200",
    green: "bg-green-100 text-green-900 border-green-300",
    amber: "bg-amber-100 text-amber-900 border-amber-300",
    red: "bg-red-100 text-red-900 border-red-300",
  };
  return (
    <Card className={`border ${tones[tone]}`} data-testid={testid}>
      <CardContent className="p-3">
        <p className="text-[11px] font-semibold tracking-wide uppercase opacity-70">{label}</p>
        <p className="text-sm font-extrabold mt-1 break-words">{value}</p>
      </CardContent>
    </Card>
  );
}
